<template>
  <section id="quiz" class="pb-8">
    <v-container fluid="fluid">
      <v-row align="center" justify="center">
        <v-col cols="10">
          <h1 class="text-center font-weight-bold display-2">SKY+ Quiz</h1>
          <h3 class="font-weight-light mt-5 mb-3 text-center">
            You are almost done! To make sure that you have completed this
            tutorial, please answer the following questions.
          </h3>
        </v-col>
      </v-row>
      <!-- Quiz -->
      <v-container>
        <v-row align="center" justify="center">
          <v-col cols="12" lg="6" sm="12">
            <question :questionData="q1" :attemptNumber="aNum" />
          </v-col>
          <v-col cols="12" lg="6" sm="12">
            <question :questionData="q2" :attemptNumber="aNum" />
          </v-col>
          <v-col cols="12" lg="6" sm="12">
            <question :questionData="q3" :attemptNumber="aNum" />
          </v-col>
          <v-col cols="12" lg="6" sm="12">
            <question :questionData="q4" :attemptNumber="aNum" />
          </v-col>
        </v-row>
        <!-- Action -->
        <v-row class="mt-0" align="center" justify="center">
          <v-col cols="12" sm="8" class="mt-3">
            <!-- responsubmit , null or Incorrect -->
            <v-alert
              dense
              type="error"
              :color="this.alertMsg.color"
              v-if="this.alertMsg.boolean"
              >{{ this.alertMsg.textMsg }}</v-alert
            >
            <!-- btn send quiz -->
            <v-btn
              block
              dark
              color="indigo darken-4"
              class="mt-2"
              @click="SendAnswers()"
            >
              Submit answer
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <!-- Dialog -->
      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title class="text-h5 txtPass font-weight-bold"
            >Success</v-card-title
          >
          <v-card-text>
            <v-alert
              class="mt-2 mb-0"
              dense
              text
              icon="mdi-shield-check"
              type="success"
            >
              You have <strong>passed</strong> the tutorial.
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false"> OK </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </section>
</template>

<script>
import question from "@/components/shared/Question";
export default {
  components: {
    question,
  },
  data: () => ({
    q1: {
      questionText: "1. Can you choose a particular section to register for?",
      choices: [
        { choiceText: "Yes, I can choose a specific section during planning." },
        { choiceText: "No, the system will pick the best section for me." },
        {
          choiceText:
            "No, the system will randomly assign me a section automatically.",
        },
        { choiceText: "None of the above." },
      ],
      answerIndex: 0,
      score: 0,
    },
    q2: {
      questionText: "2. What is the maximum number of drafts you can create?",
      choices: [
        { choiceText: "up to 1 draft." },
        { choiceText: "up to 5 drafts." },
        { choiceText: "up to 10 drafts." },
        { choiceText: "unlimited." },
      ],
      answerIndex: 3,
      score: 0,
    },
    q3: {
      questionText:
        "3. After successfully registering, how many times can you make changes to your schedule?",
      choices: [
        { choiceText: "up to 5 times." },
        { choiceText: "up to 10 times." },
        { choiceText: "unlimited." },
        { choiceText: "unable to make changes." },
      ],
      answerIndex: 1,
      score: 0,
    },
    q4: {
      questionText:
        "4. What are the payment methods tht SKY+ currently supports?",
      choices: [
        { choiceText: "QR Payment" },
        { choiceText: "Credit card (VISA, Master, JCB)" },
        { choiceText: "E-Wallet (Alipay, WeChat Pay)" },
        { choiceText: "All of the above." },
      ],
      answerIndex: 3,
      score: 0,
    },
    aNum: 0,
    totalScore: 0,
    alertMsg: {
      color: null,
      textMsg: null,
      boolean: null,
    },
    dialog: false,
  }),
  methods: {
    async SendAnswers() {
      this.aNum += 1;
      let scoreAnswer =
        this.q1.score + this.q2.score + this.q3.score + this.q4.score;
      if (scoreAnswer === 4) {
        try {
          const completeTranning = await this.$http.post(
            "/sky-training/user/",
            "",
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
          if (completeTranning.status === 201) {
            this.alertMsg.boolean = false;
            this.dialog = true;
            this.$emit("setVerify", "yes");
          } else {
            throw { completeTranning };
          }
        } catch (error) {
          this.alertMsg.color = "red";
          this.alertMsg.textMsg =
            "Error submiting your answers. Pleses refresh the page and try again.";
          this.alertMsg.boolean = true;
        }
      } else {
        this.alertMsg.color = "red";
        this.alertMsg.textMsg =
          "Some of your answers are incorrect. Pleses try again!";
        this.alertMsg.boolean = true;
      }
    },
  },
};
</script>


<style scoped="scoped">
#quiz {
  background-color: #f4f7f5;
}
.txtCorrect {
  color: red;
}
label {
  font-size: 18px;
}
.txtQuestion /deep/ label {
  font-size: 16px;
}
.fontQuestion {
  font-size: 18px;
}
.txtPass {
  color: green;
}
</style>